import { CloseOutlined, InsertDriveFile } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import './AttachmentHolder.scss';

export type AttachmentHolderProps = {
  image?: string;
  file?: File | null;
  onClose: () => void;
};

export const AttachmentHolder: React.FC<AttachmentHolderProps> = ({
  image,
  file,
  onClose,
}) => {
  const renderFile = () => {
    if (file!.type.includes('image')) {
      return <img alt="captured" src={URL.createObjectURL(file!)} />;
    }

    return (
      <div className="d-flex flex-column overflow-hidden">
        <InsertDriveFile className="file-image" />
        <span className="h6">{file?.name}</span>
      </div>
    );
  };

  return (
    <div className="attachment-holder position-absolute">
      <div className="d-flex p-2 position-relative overflow-hidden w-100 justify-content-between align-items-start">
        {image && <img alt="captured" src={image} />}
        {file && renderFile()}
        <div className="flex-grow-1" />
        <IconButton className="close-btn" onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </div>
    </div>
  );
};
